import { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance.js";
import Pagination from "../../common/Pagination/index.js";
import Loader from "../../common/Loader/index.js";
import { BiSolidEditAlt } from "react-icons/bi";
import { MdClose, MdDeleteForever } from "react-icons/md";
import FormFields from "../../common/FormFields/index.js";
import Model from "../../common/Model/index.js";
import { LiaSearchPlusSolid } from "react-icons/lia";
import { notify, Toast } from "../../common/Toast/index.js";
import { getEntityFields } from "../../utlis/entityConfig.js";
import { getUserMenuPermission } from "../../common/Helper/index.js";
import { number } from "framer-motion";

const Architect = () => {
  const permission = getUserMenuPermission(2);
  const [isArchitectData, setIsArchitectData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModelOpen, setIsModelOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;
  const [totalPages, setTotalPages] = useState(1);
  const [isEditing, setIsEditing] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalRecords, setTotalRecords] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [formData, setFormData] = useState({
    architect_ID: 0,
    name: "",
    contactNo: "",
    email: "",
    firmName: "",
    officeAddress: "",
  });
  const userId = localStorage.getItem("userId");

  const fetchArchitectData = async () => {
    try {
      setLoading(true);
      const res = await axiosInstance.post(
        `Architect/GetAll/?pageNumber=${currentPage}&pageSize=${pageSize}`,
        {
          pageNumber: currentPage,
          pageSize,
          architectId: 0,
        }
      );
      setIsArchitectData(res.data.architects);
      setFilteredData(res.data.architects);
      setTotalRecords(res.data.total_Records);
      setTotalPages(Math.ceil(res.data.total_Records / pageSize));
    } catch (err) {
      console.error("Error fetching data:", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchArchitectData();
  }, [currentPage]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleAddArchitect = () => {
    if (!permission.isInsert) {
      notify("You don't have permission to add Architect.", "error");
      return;
    }
    setFormData({
      architect_ID: "",
      name: "",
      contactNo: "",
      email: "",
      firmName: "",
      officeAddress: "",
    });
    setIsEditing(false);
    setIsModelOpen(true);
  };

  const handleEditArchitect = async (id) => {
    try {
      const { data } = await axiosInstance.get(`Architect/GetById/${id}`);
      if (data) {
        setFormData({
          architect_ID: data.architect_ID || "",
          name: data.architect_Name || "",
          contactNo: data.contact_No || "",
          email: data.email_ID || "",
          firmName: data.firm_Name || "",
          officeAddress: data.office_Address || "",
        });
        setIsEditing(true);
        setIsModelOpen(true);
      }
    } catch (err) {
      notify("Error fetching Architect data:", err);
    }
  };

  const handleDeleteArchitect = (id) => {
    setSelectedId(id);
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axiosInstance.delete(`Architect/Delete/${selectedId}`);
      fetchArchitectData();
      notify("Architect deleted successfully!", "error");
    } catch (err) {
      notify("Failed to delete Architect!", "error");
    } finally {
      setIsDeleteModalOpen(false);
      setSelectedId(null);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!isEditing && !permission.isInsert) return;
    if (isEditing && !permission.isUpdate) return;
    try {
      const payload = {
        Contact_No: formData.contactNo,
        Email_ID: formData.email,
        Firm_Name: formData.firmName,
        architect_Name: formData.name,
        Office_Address: formData.officeAddress,
        ...(formData.architect_ID
          ? { architect_ID: parseInt(formData.architect_ID, 10) }
          : {}),
        Created_By: Number(userId),
        UpdatedBy: Number(userId),
      };

      await axiosInstance.post("Architect/SaveUpdate", payload);
      fetchArchitectData();
      setIsModelOpen(false);
      notify(
        isEditing
          ? "Architect updated successfully!"
          : "Architect added successfully!",
        "success"
      );
    } catch (err) {
      notify("Error submitting form:", "error");
    }
  };
  const fetchFilteredArchitect = async (query) => {
    try {
      setLoading(true);
      const res = await axiosInstance.get(
        `Architect/FilterByName?architectName=${query}`
      );
      setFilteredData(res.data);
      setTotalRecords(res.data.length);
    } catch (err) {
      notify("Error fetching filtered data", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (searchQuery.trim() === "") {
      fetchArchitectData();
    } else {
      fetchFilteredArchitect(searchQuery);
    }
  }, [searchQuery, currentPage]);

  const clearSearch = () => {
    setSearchQuery("");
    fetchArchitectData();
  };
  return (
    <>
      <Toast />
      <div >
        <div className="rounded-3xl bg-transparent px-2 pt-2 pb-6">
          <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
            <div>
              <h2 className="text-2xl font-bold text-gray-800 tracking-tight">Architect Registry</h2>
              <p className="text-sm text-gray-500 font-medium">Manage and monitor all partner architects</p>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 w-full md:w-auto">
              <div className="relative w-full sm:w-[300px]">
                <input
                  type="text"
                  className="w-full bg-white border border-gray-100 py-2.5 pl-10 pr-10 rounded-xl focus:ring-2 focus:ring-primary/10 focus:border-primary outline-none text-sm shadow-sm transition-all"
                  placeholder="Search architects..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
                <button className="absolute left-3 top-1/2 transform -translate-y-1/2 text-primary/60">
                  <LiaSearchPlusSolid className="w-5 h-5" />
                </button>
                {searchQuery && (
                  <button
                    onClick={clearSearch}
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-red-400 hover:text-red-500 transition-colors"
                  >
                    <MdClose className="w-5 h-5" />
                  </button>
                )}
              </div>
              {permission.isInsert && (
                <button
                  className="w-full sm:w-auto flex items-center justify-center gap-2 bg-primary hover:bg-primary/95 text-white px-6 py-2.5 rounded-xl font-bold shadow-lg shadow-primary/20 transition-all active:scale-95"
                  onClick={handleAddArchitect}
                >
                  <span>+</span> Add Architect
                </button>
              )}
            </div>
          </div>

          <div className="premium-card overflow-hidden border-none shadow-xl shadow-gray-200/50">
            {loading ? (
              <div className="p-20 flex justify-center"><Loader /></div>
            ) : permission.isView ? (
              <div className="overflow-x-auto">
                <table className="w-full text-sm text-left">
                  <thead className="bg-[#f9fafc] text-[#405189] uppercase tracking-wider text-[11px] font-bold border-b border-gray-100">
                    <tr>
                      <th className="px-6 py-4">Name</th>
                      <th className="px-6 py-4">Contact</th>
                      <th className="px-6 py-4">Email</th>
                      <th className="px-6 py-4">Firm</th>
                      <th className="px-6 py-4">Address</th>
                      <th className="px-6 py-4 text-center">Actions</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-50 bg-white">
                    {filteredData?.length > 0 ? (
                      filteredData.map((architect) => (
                        <tr
                          key={architect.architect_ID}
                          className="hover:bg-blue-50/30 transition-colors group cursor-pointer"
                        >
                          <td className="px-6 py-4 font-bold text-gray-800">
                            {architect.architect_Name}
                          </td>
                          <td className="px-6 py-4 font-medium text-gray-600">
                            {architect.contact_No}
                          </td>
                          <td className="px-6 py-4 text-gray-500 font-medium">
                            {architect.email_ID}
                          </td>
                          <td className="px-6 py-4">
                            <span className="px-2.5 py-1 bg-primary/5 text-primary rounded-lg text-[11px] font-bold uppercase tracking-wider">
                              {architect.firm_Name}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-gray-500 max-w-[200px] truncate italic text-xs">
                            {architect.office_Address}
                          </td>
                          <td className="px-6 py-4">
                            <div className="flex items-center justify-center gap-2 opacity-0 group-hover:opacity-100 transition-opacity">
                              {permission.isUpdate && (
                                <button
                                  className="p-2 bg-gray-50 text-gray-600 hover:bg-blue-50 hover:text-blue-600 rounded-lg transition-colors"
                                  onClick={(e) => { e.stopPropagation(); handleEditArchitect(architect.architect_ID); }}
                                  title="Edit Architect"
                                >
                                  <BiSolidEditAlt className="w-4 h-4" />
                                </button>
                              )}
                              {permission.isDelete && (
                                <button
                                  className="p-2 bg-gray-50 text-red-400 hover:bg-red-50 hover:text-red-600 rounded-lg transition-colors"
                                  onClick={(e) => { e.stopPropagation(); handleDeleteArchitect(architect.architect_ID); }}
                                  title="Delete Architect"
                                >
                                  <MdDeleteForever className="w-4 h-4" />
                                </button>
                              )}
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="6" className="text-center py-20 text-gray-400 font-medium italic">
                          No architects found matching your criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center text-red-500 text-lg py-20 font-bold bg-white">
                Access Denied: You don't have permission to view architects.
              </div>
            )}

            <div className="bg-[#f9fafc] px-6 py-4 border-t border-gray-100 flex flex-col sm:flex-row justify-between items-center gap-4">
              <p className="text-[13px] text-gray-500 font-medium">
                Showing <span className="font-bold text-gray-800">
                  {isArchitectData?.length > 0 ? (currentPage - 1) * pageSize + 1 : 0} to {Math.min(currentPage * pageSize, totalRecords)}
                </span> of{" "}
                <span className="font-bold text-gray-800">{totalRecords}</span> records
              </p>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={setCurrentPage}
              />
            </div>
          </div>
        </div>
      </div>

      <Model
        isOpen={isModelOpen}
        onClose={() => setIsModelOpen(false)}
        name={isEditing ? "Edit Architect" : "Add Architect"}
      >
        <div className="p-1">
          <FormFields
            onSubmit={handleSubmit}
            setIsModelOpen={setIsModelOpen}
            formData={formData}
            handleInputChange={handleInputChange}
            fields={getEntityFields("architect")}
            onClear={() => setIsModelOpen(false)}
            isEditing={isEditing}
          />
        </div>
      </Model>

      <Model
        isOpen={isDeleteModalOpen}
        onClose={() => setIsDeleteModalOpen(false)}
      >
        <div className="p-8 text-center">
          <div className="w-16 h-16 bg-red-50 text-red-500 rounded-full flex items-center justify-center mx-auto mb-4">
            <MdDeleteForever className="w-8 h-8" />
          </div>
          <h3 className="text-xl font-bold text-gray-800 mb-2">Confirm Delete</h3>
          <p className="text-gray-500 mb-8 max-w-[300px] mx-auto">
            Are you sure you want to permanently delete this architect? This action cannot be undone.
          </p>
          <div className="flex justify-center gap-3">
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-gray-600 bg-gray-100 hover:bg-gray-200 transition-colors"
              onClick={() => setIsDeleteModalOpen(false)}
            >
              Cancel
            </button>
            <button
              className="px-6 py-2.5 rounded-xl font-bold text-white bg-red-500 hover:bg-red-600 shadow-lg shadow-red-200 transition-all active:scale-95"
              onClick={handleConfirmDelete}
            >
              Delete Architect
            </button>
          </div>
        </div>
      </Model>
    </>
  );
};

export default Architect;
